'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    save: 'Save',
    send: 'Send',
    next: 'Next',
    prev: 'Previous',
    required: 'Required field',
    minLengthField: 'Not enough characters',
    incorrectEmail: 'Incorrect email format',
    incorrectDate: 'Incorrect date format',
    month: 'Month',
    monthYearError: 'Month and year are required',
    yearError: 'Year is required',
    monthError: 'Month is required',
    dayError: 'Day is required',
    dayYearError: 'Day and Year are required',
    dayMonthError: 'Day and month are required',
    empty: 'No data',
    add: 'Add',
    delete: 'Delete',
    cancel: 'Cancel',
    age: 'Age',
    workExperience: 'Work experience is',
    selectDate: 'Select date',
    selectMonth: 'Select month',
    minLength: 'The document cannot be saved, because the required number of characters is not entered!\nMin number of characters: {minLength}\nCharacters entered: {length}',
    minLengthText: 'Document characters: {length} out of {minLength}',
    lengthText: 'Characters in document, with pre-filled fields included: {length}',
    noWorkloadText: 'Document not count in Workload report',
    workloadText: 'Document will count in Workload repor with any number of characters',
    workloadMinText: 'Minimal characters for Workload: {minLength}, \u043E\u0434\u043D\u0430\u043A\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u043C \u0444\u043E\u0440\u043C\u044B \u043D\u0438 \u043E\u0434\u0438\u043D \u0432\u043E\u043F\u0440\u043E\u0441 \u043D\u0435 \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432 Workload',
    workloadCurrentLengthText: 'Characters for Workload: {length} out of {minLength}',
    deleteConfirm: 'Данные, удаляемые/ изменяемые в документе, также будут удалены/изменены в карточке Experium.',
    deleteDescription: 'Вы уверены, что хотите удалить их в документе и в карточке?',
    deleteOk: 'Да',
    deleteCancel: 'Нет',
    selectInput: 'Выбор в БД',
    addBlockTop: 'Добавить сверху',
    addBlockBottom: 'Добавить снизу'
};